import { apiSlice } from "../api/apiSlice";

export const assignmentsAPI = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAssignments: builder.query({
      query: () => "/assignments",
    }),
    getAssignment: builder.query({
      query: (id) => `/assignments/${id}`,
    }),
    getAssignmentOfVideo: builder.query({
      query: (video_id) => `/assignments?video_id=${video_id}`,
    }),
    addAssignment: builder.mutation({
      query: (data) => ({
        url: "/assignments",
        method: "POST",
        body: data,
      }),

      async onQueryStarted(data, { queryFulfilled, dispatch }) {
        try {
          const addResult = await queryFulfilled;
          dispatch(
            apiSlice.util.updateQueryData(
              "getAssignments",
              undefined,
              (draft) => {
                draft.push(addResult.data);
              }
            )
          );
        } catch (error) {
          console.error("Something Went Wrong!");
          console.error(error);
        }
      },
    }),
    editAssignment: builder.mutation({
      query: ({ id, data }) => ({
        url: `/assignments/${id}`,
        method: "PATCH",
        body: data,
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const editResult = await queryFulfilled;

          //Update Tasks Cache
          await dispatch(
            apiSlice.util.updateQueryData(
              "getAssignments",
              undefined,
              (draft) => {
                let target = draft.findIndex(
                  (assignment) => Number(assignment.id) === arg.id
                );
                draft[target] = editResult.data;
              }
            )
          );

          //Update Task Cache for edit
          const id = String(arg.id);
          await dispatch(
            apiSlice.util.updateQueryData("getAssignment", id, (draft) => {
              draft.title = editResult.data.title;
              draft.video_id = editResult.data.video_id;
              draft.video_title = editResult.data.video_title;
              draft.totalMark = editResult.data.totalMark;
            })
          );
        } catch (error) {
          console.error("Something went Wrong!");
        }
      },
    }),
    deleteAssignment: builder.mutation({
      query: (id) => ({
        url: `assignments/${id}`,
        method: "DELETE",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        const deleteResult = dispatch(
          apiSlice.util.updateQueryData(
            "getAssignments",
            undefined,
            (draft) => {
              const targetIndex = draft.findIndex(
                (assignment) => Number(assignment.id) === arg
              );
              draft.splice(targetIndex, 1);
            }
          )
        );

        try {
          const result = await queryFulfilled;
          if (result.meta.response.status === 200) {
            console.log("Successfully Deleted!");
          }
        } catch (error) {
          deleteResult.undo();
          console.log(error);
        }
      },
    }),
  }),
});

export const {
  useGetAssignmentsQuery,
  useGetAssignmentQuery,
  useGetAssignmentOfVideoQuery,
  useAddAssignmentMutation,
  useEditAssignmentMutation,
  useDeleteAssignmentMutation,
} = assignmentsAPI;
